<template>
	<v-app>
		<v-main>
			<router-view />
		</v-main>
	</v-app>
</template>

<script>
import { GTAG_KEY } from './utils/constants'
export default {
	name: 'App',
	setup() {
	},

	beforeMount() {
		const host = window.location.host;
		let hostType = 'DEV'

		if (host.startsWith('5tbyqce941455yffg7fzg36tp6or8p.ext-twitch.tv')) {
			hostType = 'PROD'
		}

		const gtagKey = document.createElement('script');
		gtagKey.src = `https://www.googletagmanager.com/gtag/js?id=${GTAG_KEY[hostType]}`;
		gtagKey.async = true;

		document.head.appendChild(gtagKey);

		// Define a callback function to initialize Google Analytics
		window['dataLayer'] = window['dataLayer'] || [];
		function gtag() {
			window['dataLayer'].push(arguments);
		}
		window['gtag'] = gtag;

		gtagKey.onload = () => {
			gtag('js', new Date());
			gtag('config', GTAG_KEY[hostType]);
		};
	}
};
</script>
